(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mtb__nav-mobile"] && !Shopify.designMode) return;
  try {
    function initMTBMobileNav(container) {
    const hamburger = container.querySelector('.mtb__nav-mobile-hamburger');
    const drawer = container.querySelector('.mtb__nav-drawer');
    const overlay = container.querySelector('.mtb__nav-overlay');
    const closeBtn = container.querySelector('.mtb__nav-mobile-close');

    if (!hamburger || !drawer) return;

    const openMenu = () => {
        drawer.classList.add('open');
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    };

    const closeMenu = () => {
        drawer.classList.remove('open');
        overlay.classList.remove('open');
        document.body.style.overflow = '';
    };

    hamburger.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
}

/* Storefront load */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mtb__nav-mobile').forEach(initMTBMobileNav);
});

/* Theme editor support */
document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector('.mtb__nav-mobile');
    if (container) initMTBMobileNav(container);
});
  } catch(e) { console.error(e); }
})();

})();
